var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-col gap-y-md"},[_c('dd-header-card',{attrs:{"header":"Algemene instellingen"}},[_c('GeneralSettings')],1),_vm._v(" "),_c('ChooseAutomationActions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }